/* Sauer's Bakehouse — quick "Add to cart" buttons for the cart-page upsell
   ("You'll love this too"). Adds an always-visible pill to each upsell card
   that adds the product's first available variant via AJAX and live-refreshes
   the cart line items + subtotal (Shopify Section Rendering). Self-contained:
   does not depend on the theme's quick-view store. Scoped to #main-cart-upsell. */
(function () {
  if (window.__srUpsellAtc) return;
  window.__srUpsellAtc = true;

  var ROOT_SEL = '#main-cart-upsell';
  var ADD_HTML =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 4h2l2.4 12.3a1 1 0 0 0 1 .8h8.8a1 1 0 0 0 1-.8L21 8H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="20" r="1.4" fill="currentColor"/><circle cx="17.5" cy="20" r="1.4" fill="currentColor"/></svg>' +
    '<span class="sr-qadd__lbl">Add to cart</span>';
  var ADDED_HTML =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '<span class="sr-qadd__lbl">Added</span>';

  var css = ''
    + ROOT_SEL + ' .card-product-img{position:relative}'
    + ROOT_SEL + ' .sr-qadd{position:absolute;left:50%;bottom:12px;transform:translateX(-50%);'
    +   'display:inline-flex;align-items:center;gap:7px;white-space:nowrap;'
    +   'background:#1f2c4c;color:#f4e9d2;border:2px solid #f4e9d2;border-radius:999px;'
    +   'padding:9px 15px;font-family:inherit;font-size:13px;font-weight:700;letter-spacing:.02em;'
    +   'cursor:pointer;box-shadow:0 6px 16px rgba(31,44,76,.28);z-index:6;'
    +   'transition:transform .18s ease,background .18s ease,opacity .18s ease}'
    + ROOT_SEL + ' .sr-qadd:hover{background:#e0843f;border-color:#e0843f;transform:translateX(-50%) translateY(-2px)}'
    + ROOT_SEL + ' .sr-qadd:disabled{cursor:default}'
    + ROOT_SEL + ' .sr-qadd.is-added{background:#4f7d4f;border-color:#cdebb9}'
    + ROOT_SEL + ' .sr-qadd.is-loading .sr-qadd__lbl{opacity:.55}'
    + ROOT_SEL + ' .sr-qadd svg{width:15px;height:15px;flex:0 0 auto}'
    + '@media (max-width:600px){' + ROOT_SEL + ' .sr-qadd{font-size:12px;padding:8px 13px}}';

  function injectStyle() {
    if (document.getElementById('sr-qadd-style')) return;
    var s = document.createElement('style');
    s.id = 'sr-qadd-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function sectionId(suffix) {
    var el = document.querySelector('[id^="shopify-section-"][id$="__' + suffix + '"]')
          || document.getElementById('shopify-section-' + suffix);
    return el ? el.id.replace('shopify-section-', '') : null;
  }
  function swapSection(id, html) {
    var wrap = document.getElementById('shopify-section-' + id);
    if (!wrap || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.getElementById('shopify-section-' + id);
    wrap.innerHTML = inner ? inner.innerHTML : html;
  }
  function refreshBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var b = document.querySelector('#cart-icon-bubble span');
      if (b) b.textContent = c.item_count;
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    }).catch(function () {});
  }

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  async function quickAdd(handle, btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      var pr = await fetch('/products/' + handle + '.js');
      if (!pr.ok) throw new Error('product');
      var p = await pr.json();
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) throw new Error('variant');
      // refresh only the cart line items + footer; leave the upsell (and its buttons) intact
      var ids = ['cart-items', 'cart-footer'].map(sectionId).filter(Boolean);
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, sections: ids.join(','), sections_url: location.pathname })
      });
      if (!res.ok) throw new Error('add');
      var data = await res.json();
      if (data.sections) ids.forEach(function (id) { swapSection(id, data.sections[id]); });
      refreshBubble();
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = ADDED_HTML;
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
        btn.innerHTML = ADD_HTML;
      }, 1900);
    } catch (e) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  function enhance(scope) {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    injectStyle();
    var cards = (scope && scope.querySelectorAll ? scope : root).querySelectorAll('.card-product');
    [].slice.call(cards).forEach(function (card) {
      if (card.querySelector('.sr-qadd')) return;
      var handle = handleFromCard(card);
      if (!handle) return;
      // Anchor the pill to the image box, not the whole card. `.card-product-img`
      // only exists on multi-image slider cards; the cart upsell's single-image
      // cards wrap the image in `a.link-product-variant`, and the title/rating/
      // price sit in that same wrapper below the image — so anchoring to the card
      // (or the outer wrapper) drops the pill onto the rating row. The image link
      // itself is sized to just the image, and the theme already nests its own
      // quick-view buttons there, so it's the correct positioned ancestor.
      var host = card.querySelector('.card-product-img')
              || card.querySelector('a.link-product-variant');
      if (!host) {
        var img = card.querySelector('a[href*="/products/"] img') || card.querySelector('img');
        if (img) host = img.closest('a') || img.parentElement;
      }
      host = host || card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sr-qadd';
      btn.setAttribute('aria-label', 'Add to cart');
      btn.innerHTML = ADD_HTML;
      // No per-button listener: clicks are handled by delegation below, so
      // cloned cards (the marquee duplicates) work too.
      host.appendChild(btn);
    });
  }
  window.srUpsellEnhance = enhance; // test hook

  // Delegated click handler — works for original and cloned (marquee) buttons.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sr-qadd');
    if (!btn || !btn.closest(ROOT_SEL)) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.card-product');
    var handle = card && handleFromCard(card);
    if (handle) quickAdd(handle, btn);
  }, true);

  function boot() {
    if (!document.querySelector(ROOT_SEL)) return;
    enhance();
    // upsell cards arrive async (recommendations / Alpine teleport) and the
    // section can re-render — keep enhancing as nodes appear.
    var root = document.querySelector(ROOT_SEL);
    var mo = new MutationObserver(function () { enhance(); });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
